import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { GridDensity, IPreviewImage } from 'types/store';

import initialState from './initialState';

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setIsShowCloseModal(state, { payload }: PayloadAction<boolean>) {
      state.isShowCloseModal = payload;
    },
    setIsOpenedFromCloseModal(state, { payload }: PayloadAction<boolean>) {
      state.isOpenedFromCloseModal = payload;
    },
    setPreviewImage(state, { payload }: PayloadAction<IPreviewImage | undefined>) {
      state.previewImage = payload;
    },
    setGridDensity(state, { payload }: PayloadAction<GridDensity>) {
      state.gridDensity = payload;
    },
  },
});

export default uiSlice;
